import { getCountryEmoji } from './getCountryEmoji';
import { getCountryName } from './getCountryName';

export function getCountryLabel(countryCode: string, { locale = 'en', emoji = true } = {}) {
  const name = getCountryName(countryCode, { locale });
  if (!name) {
    return '';
  }

  if (emoji) {
    return `${getCountryEmoji(countryCode)} ${name}`;
  }

  return name;
}
